import React from 'react';
import { Spinner, Box } from '@amzn/awsui-components-core';

/**
 * RouteLoadingFallback Component
 *
 * Provides a consistent loading experience across all lazy-loaded routes.
 * Uses Cloudscape Spinner component for brand consistency.
 *
 * This component is shown while route chunks are being downloaded and parsed.
 * It should be lightweight to avoid delaying initial render.
 */
export const RouteLoadingFallback: React.FC = () => {
  return (
    <Box textAlign="center" padding={{ vertical: 'xxxl' }}>
      <Spinner size="large" />
    </Box>
  );
};
